import { PlusOutlined } from "@ant-design/icons";

// components
import MainButton from "./Buttons/MainButton";

const MainHeader = ({
  title = null,
  info = null,
  buttonName,
  onButtonClick,
  disableBtn,
  className,
}) => {
  return (
    <header
      className={`main-header d-flex justify-content-between align-items-center gap-3 ${className}`}
    >
      {title && <h1 className="text-white mb-0 main-header__title">{title}</h1>}
      {info && (
        <strong className="text-white mt-2">
          {`${info?.courierName} : ${info?.courierMobile}`}
        </strong>
      )}
      {buttonName && (
        <MainButton
          bg="white"
          textClr="primary-1"
          textSize={10}
          text={buttonName}
          disabled={disableBtn}
          type="button"
          icon={<PlusOutlined />}
          onClick={() => {
            if (!disableBtn) onButtonClick();
          }}
          className="action-btn font--semi-bold"
        />
      )}
    </header>
  );
};

export default MainHeader;
